import React from 'react';
import { useOfferContext } from '../../../../context';
import { ContentRow } from '../../../../components/ContentRow';
import { Proof } from '../../../../components/Proof';

export const PROOF_TEXTS: { [index: string]: string } = {
  passport: 'Предоставил паспорт',
  rosreestr: 'Проверено Росреестром',
  selfEmployed: 'Сдаёт как самозанятый',
};

export function AgentProofsContainer() {
  const {
    offer: { homeownerProofs },
  } = useOfferContext();

  if (!Array.isArray(homeownerProofs) || homeownerProofs.length === 0) {
    return null;
  }

  return (
    <ContentRow>
      {homeownerProofs.map(proofType => (
        <Proof text={PROOF_TEXTS[proofType]} key={`proof-${proofType}`} />
      ))}
    </ContentRow>
  );
}
